import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "region-dashboards-dynamic-card__body" }
const _hoisted_2 = { class: "region-dashboards-dynamic-card__title" }
const _hoisted_3 = { class: "region-dashboards-dynamic-card__content" }
const _hoisted_4 = { class: "region-dashboards-dynamic-card__indicators" }
const _hoisted_5 = { class: "region-dashboards-dynamic-card__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IndicatorCard = _resolveComponent("IndicatorCard")!

  return (_openBlock(), _createBlock(_component_IndicatorCard, {
    mod: "inverted-card",
    class: _normalizeClass(["region-dashboards-dynamic-card", { 'region-dashboards-dynamic-card_loading': _ctx.isLoading }])
  }, {
    values: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.card.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicatorCardParams, (indicatorCardParam) => {
              return (_openBlock(), _createElementBlock("div", {
                key: indicatorCardParam.text,
                class: "region-dashboards-dynamic-card__indicator"
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass([
                  'region-dashboards-dynamic-card__value',
                  `region-dashboards-dynamic-card__value--${indicatorCardParam.status}`,
                ])
                }, _toDisplayString(indicatorCardParam.value ?? '-'), 3),
                _createElementVNode("p", _hoisted_5, _toDisplayString(indicatorCardParam.text), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}